const EVENTS_KEYS = {
  EVENTS: () => ['events'],
  EVENTS_PAGINATED: (params = {}) => [...EVENTS_KEYS.EVENTS(), 'paginated', params],
  EVENT: (uid) => [...EVENTS_KEYS.EVENTS(), uid],
  EVENTS_USAGE: (regionUid) => [EVENTS_KEYS.EVENTS(), 'usage', regionUid],
};

export default EVENTS_KEYS;
